const COOKIE_NAME = 'OsanoQaExpiresAt';
const TEST_DURATION_MS = 60 * 60 * 1000;

export const QA_TEST_SECTION = 'osano-qa-testing';

/** The server only sets these markers for authenticated employees in QA. */
export function canTestOsanoInQa() {
  if (document.getElementById('js-storm-osano-qa-testing-allowed')) return true;
  const configText = document.querySelector('.js-osano-init')?.textContent;
  return !!configText && JSON.parse(configText)['qaTestingAllowed'] === true;
}

export function getOsanoQaExpiration() {
  if (!canTestOsanoInQa()) return 0;
  const cookie = document.cookie.split(';').map(value => value.trim())
    .find(value => value.startsWith(COOKIE_NAME + '='));
  const expiresAt = cookie ? Number(cookie.slice(COOKIE_NAME.length + 1)) : 0;
  const now = Date.now();
  return Number.isFinite(expiresAt) && expiresAt > now && expiresAt <= now + TEST_DURATION_MS
    ? expiresAt : 0;
}

export function toggleOsanoQaTesting() {
  if (!canTestOsanoInQa()) return;
  const enable = !getOsanoQaExpiration();
  const expiresAt = enable ? Date.now() + TEST_DURATION_MS : 0;
  const maxAge = enable ? TEST_DURATION_MS / 1000 : 0;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${expiresAt}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  if (enable && !getOsanoQaExpiration()) {
    window.alert('Allow cookies to enable Osano loading.');
    return;
  }
  // The server uses the cookie to include or omit Osano on the next page load.
  window.location.reload();
}

export function initializeOsanoQaTesting() {
  if (!canTestOsanoInQa()) return;
  const expiresAt = getOsanoQaExpiration();
  if (!expiresAt) return;

  // Do not renew the opt-in on navigation. Reload to remove Osano at expiry.
  window.setTimeout(() => window.location.reload(), expiresAt - Date.now());
  // Pick up disabling or expiry in another tab when returning to this one.
  window.addEventListener('focus', () => {
    if (getOsanoQaExpiration() !== expiresAt) window.location.reload();
  });
}
